/**
 * Cart Expiration Logic
 * - Clears the cart if products have been sitting in it for more than 9 days.
 * - Adds a _added_at timestamp property to each line item for order visibility.
 * - Removes items with discount properties but no timestamp (stale discounted items).
 */
(function(){
  // Idempotent guard
  if (window.__cartExpirationRegistered) return;
  window.__cartExpirationRegistered = true;

  var CART_EXPIRY_DAYS = 9;
  var CART_TIMESTAMP_KEY = 'teeshoppen_cart_timestamp';

  // Discount-related properties that indicate an item has special pricing
  var DISCOUNT_PROPERTIES = [
    '_bsmv',      // bundle spend minimum value
    '_bsmc',      // bundle spend minimum count
    '_bsp',       // bundle spend price
    '_bsf',       // bundle spend fixed
    '_bsa',       // bundle spend active
    '_Rabat pris', // discount price
    '_Rabat_pris', // discount price alternate
    '_xy_dynamic', // dynamic bundle
    '_cql'        // custom quantity limit (sale items)
  ];

  /**
   * Format timestamp as readable date string (DD/MM/YYYY HH:MM)
   */
  function formatTimestamp(timestamp) {
    var date = new Date(timestamp);
    var day = String(date.getDate()).padStart(2, '0');
    var month = String(date.getMonth() + 1).padStart(2, '0');
    var year = date.getFullYear();
    var hours = String(date.getHours()).padStart(2, '0');
    var minutes = String(date.getMinutes()).padStart(2, '0');
    return day + '/' + month + '/' + year + ' ' + hours + ':' + minutes;
  }

  /**
   * Check if an item has any discount-related properties
   */
  function hasDiscountProperties(item) {
    if (!item.properties) return false;
    for (var i = 0; i < DISCOUNT_PROPERTIES.length; i++) {
      if (item.properties[DISCOUNT_PROPERTIES[i]] !== undefined) {
        return true;
      }
    }
    return false;
  }

  /**
   * Check if an item has a timestamp
   */
  function hasTimestamp(item) {
    return item.properties && item.properties['_added_at'] !== undefined;
  }

  /**
   * Remove stale discounted items (items with discounts but no timestamp)
   */
  function removeStaleDiscountedItems() {
    fetch('/cart.js')
      .then(function(response) { return response.json(); })
      .then(function(cart) {
        if (!cart.items || cart.items.length === 0) return;

        // Find items to remove: has discount properties but no timestamp
        var itemsToRemove = cart.items.filter(function(item) {
          return hasDiscountProperties(item) && !hasTimestamp(item);
        });

        if (itemsToRemove.length === 0) return;

        console.log('Removing ' + itemsToRemove.length + ' stale discounted item(s) from cart');

        // Remove items sequentially
        var index = 0;
        function removeNext() {
          if (index >= itemsToRemove.length) {
            // All done, refresh cart UI
            if (window.liquidAjaxCart && window.liquidAjaxCart.update) {
              window.liquidAjaxCart.update({}, {});
            }
            return;
          }

          var item = itemsToRemove[index];
          index++;

          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: item.key, quantity: 0 })
          })
          .then(function() {
            removeNext();
          })
          .catch(function(err) {
            console.warn('Failed to remove stale item:', err);
            removeNext();
          });
        }

        removeNext();
      })
      .catch(function(err) {
        console.warn('Failed to check cart for stale items:', err);
      });
  }

  /**
   * Check if cart has expired and clear it if necessary
   */
  function clearExpiredCart() {
    var timestamp = localStorage.getItem(CART_TIMESTAMP_KEY);
    if (!timestamp) return;

    var addedDate = new Date(parseInt(timestamp, 10));
    var now = new Date();
    var daysDiff = (now - addedDate) / (1000 * 60 * 60 * 24);

    if (daysDiff > CART_EXPIRY_DAYS) {
      console.log('Cart expired after ' + Math.floor(daysDiff) + ' days. Clearing cart.');

      fetch('/cart/clear.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' }
      })
      .then(function(response) {
        if (response.ok) {
          localStorage.removeItem(CART_TIMESTAMP_KEY);
          if (window.liquidAjaxCart && window.liquidAjaxCart.update) {
            window.liquidAjaxCart.update({}, {});
          }
        }
      })
      .catch(function(err) {
        console.warn('Failed to clear expired cart:', err);
      });
    }
  }

  /**
   * Inject or update _added_at timestamp input in a form
   */
  function ensureTimestampOnForm(form) {
    if (!form) return null;
    var input = form.querySelector('input[name="properties[_added_at]"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'properties[_added_at]';
      form.appendChild(input);
    }
    input.value = formatTimestamp(Date.now());
    return input;
  }

  /**
   * Set localStorage timestamp when items are added
   */
  function handleCartUpdate(e) {
    try {
      var requestState = e.detail && e.detail.requestState;
      if (!requestState || !requestState.responseData) return;

      var itemCount = requestState.responseData.item_count;

      if (requestState.requestType === 'add' && itemCount > 0) {
        if (!localStorage.getItem(CART_TIMESTAMP_KEY)) {
          localStorage.setItem(CART_TIMESTAMP_KEY, Date.now().toString());
        }
      }

      if (itemCount === 0) {
        localStorage.removeItem(CART_TIMESTAMP_KEY);
      }
    } catch (err) { /* ignore */ }
  }

  /**
   * Initialize localStorage timestamp if cart has items but no timestamp
   */
  function initializeTimestamp() {
    fetch('/cart.js')
      .then(function(response) { return response.json(); })
      .then(function(cart) {
        if (cart.item_count > 0 && !localStorage.getItem(CART_TIMESTAMP_KEY)) {
          localStorage.setItem(CART_TIMESTAMP_KEY, Date.now().toString());
        } else if (cart.item_count === 0) {
          localStorage.removeItem(CART_TIMESTAMP_KEY);
        }
      })
      .catch(function() { /* ignore */ });
  }

  // Attach listeners after DOM ready
  document.addEventListener('DOMContentLoaded', function(){
    function attachToForms(){
      var forms = Array.prototype.slice.call(
        document.querySelectorAll('ajax-cart-product-form form, form.product_form, form[action*="/cart/add"]')
      );
      forms.forEach(function(form){
        if (!form.__timestampListenerAttached){
          // Inject on page load
          ensureTimestampOnForm(form);
          // Refresh on submit
          form.addEventListener('submit', function(){ ensureTimestampOnForm(form); }, { capture: true });
          form.__timestampListenerAttached = true;
        }
      });
    }
    attachToForms();

    // Delegate clicks for quick-add buttons
    document.body.addEventListener('click', function(e){
      var target = e.target;
      var btn = target.closest && target.closest('button[name="add"], button[type="submit"], .cart-submit, #addToCartButton');
      if (!btn) return;
      var form = btn.closest && btn.closest('form');
      if (form) ensureTimestampOnForm(form);
    }, { passive: true });

    // MutationObserver for dynamically added forms
    var observer = new MutationObserver(function(mutations){
      mutations.forEach(function(mutation){
        mutation.addedNodes.forEach(function(node){
          if (node.nodeType !== 1) return;
          if (node.tagName === 'FORM') {
            var action = node.getAttribute('action') || '';
            if (action.includes('/cart/add')) {
              ensureTimestampOnForm(node);
            }
          } else if (node.querySelectorAll) {
            var forms = node.querySelectorAll('form[action*="/cart/add"], ajax-cart-product-form form');
            forms.forEach(function(form){
              ensureTimestampOnForm(form);
            });
          }
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  });

  // Hook into liquid-ajax-cart lifecycle for AJAX adds
  document.addEventListener('liquid-ajax-cart:request-start', function(ev){
    try {
      var requestState = (ev && ev.detail && ev.detail.requestState) || null;
      if (!requestState) return;
      var initiator = requestState.info && requestState.info.initiator;
      if (initiator && typeof initiator.closest === 'function') {
        var form = initiator.closest('form');
        if (form) ensureTimestampOnForm(form);
      } else {
        var productForm = document.querySelector('ajax-cart-product-form form') ||
                          document.querySelector('form.product_form') ||
                          document.querySelector('form[action*="/cart/add"]');
        if (productForm) ensureTimestampOnForm(productForm);
      }
    } catch(e) { /* swallow errors */ }
  });

  // Listen for cart updates to manage localStorage timestamp
  document.addEventListener('liquid-ajax-cart:request-end', handleCartUpdate);

  // Check for expired cart on page load
  clearExpiredCart();

  // Remove stale discounted items (items with discounts but no timestamp)
  removeStaleDiscountedItems();

  // Initialize timestamp if needed
  initializeTimestamp();
})();
